require('./filters.js')
require('./app.html')
require('riot').mount('app')
